export default "__VITE_ASSET__BgNMHRm3__"